/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./FileUploadComponent.vue?vue&type=template&id=380ba976&scoped=true&lang=html&"
import script from "./FileUploadComponent.vue?vue&type=script&lang=js&"
export * from "./FileUploadComponent.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadComponent.vue?vue&type=style&index=0&id=380ba976&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ba976",
  null
  
)

export default component.exports